import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AttachmentViewerComponent } from './shared/attachment-viewer/attachment-viewer.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AttachmentViewerComponent],
  template: '<router-outlet /><mac-attachment-viewer />',
})
export class App {}
